export const HOME_ROUTES = {
  MAIN_PATH: '/',
  HELP_PATH: '/help',
};
